/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Download, Edit, Eye, Image, Trash2, Check } from "react-feather";

const MainTable = (props) => {
  const {
    screenName = "",
    withActions = false,
    showEdit = true,
    showSubmit = false,
    showDelete = true,
    showView = false,
    showDownload = false,
    showImgView = false,
    rowSelection,
    loading = false,
    bordered = false,
    size = "middle",
    emptyText = "No data available",
    scroll,
    footer,
    showSearch = true,
    showPagination = true, // ✅ added prop (default true)
    customActions = null
  } = props.options;

  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  }, []);

  const enhancedColumns = [...props.columns];

  if (withActions) {
    enhancedColumns.push({
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        customActions
          ? customActions(record)
          :
          <td className="action-table-data">
            <div className="edit-delete-action">
              {showView && (
                <button type="button" className="mybtn" onClick={() => props.onView?.(record)}>
                  <Eye className="feather-eye1" />
                </button>
              )}
              {showImgView && (
                <button type="button" className="mybtn" onClick={() => props.onImgView?.(record)}>
                  <Image className="feather-eye1" />
                </button>
              )}
              {showDownload && (
                <button type="button" className="mybtn" onClick={() => props.onDownload?.(record)}>
                  <Download className="feather-trash21" />
                </button>
              )}
              {showEdit && (
                <button type="button" className="mybtn" onClick={() => props.onEdit?.(record)}>
                  <Edit className="feather-edit31" />
                </button>
              )}
              {showDelete && (
                <button type="button" className="mybtn" onClick={() => props.onDelete?.(record)}>
                  <Trash2 className="feather-trash21" />
                </button>
              )}
              {showSubmit && (
                <button
                  type="button"
                  className="mybtn"
                  onClick={() => props.onSubmit?.(record)}
                >
                  <Check className="feather-check" />
                </button>
              )}
            </div>
          </td>

      ),
    });
  }

  return (
    <div className="table-responsive">
      <Table
        columns={enhancedColumns}
        dataSource={[...(props.dataSource ?? [])].reverse()}
        pagination={
          showPagination
            ? {
              ...pagination,
              showSizeChanger: true,
              pageSizeOptions: ["10", "15", "20", "50", "100"],
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              onChange: (page, pageSize) => {
                setPagination({ current: page, pageSize });
              },
            }
            : false // ✅ disable pagination
        }
        rowSelection={props.rowSelection}
        // Screens pass loading either as a prop or inside options
        loading={props.loading ?? loading}
        bordered={bordered}
        size={size}
        scroll={scroll}
        locale={{ emptyText }}
        footer={footer}
        rowKey={props.options?.rowKey || "id"}
      />
    </div>
  );
};

export default MainTable;
